module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1231.6a3834d6.png";